'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var SearchResult = require('./SearchResult.js');
var MapCanvas = require('./MapCanvas.js');
var accessibilityHelper = require('../../../lib/ADAHelpers');

module.exports = function (_React$Component) {
    _inherits(_class2, _React$Component);

    function _class2() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            isFavorite: _this.props.isFavorite || false
        }, _this.hideModal = function () {
            accessibilityHelper.focusOnElementAfterModalTransition('#find-distance-' + _this.props.location.id, 'close');
            _this.props.Actions.hideGenericModal();
        }, _this.favoriteLocationClick = function (loc, isFav) {
            _this.setState({ isFavorite: !_this.state.isFavorite });
            if (_this.props.favoriteLocationClick) {
                _this.props.favoriteLocationClick(loc, isFav);
            }
        }, _this.keepTrappedInModal = function (e) {
            if (e.keyCode === 9) {
                if (e.target.id === 'modal-close-button' && e.shiftKey) {
                    e.preventDefault();
                    e.stopPropagation();
                    document.querySelector('#product-fav-icon').focus();
                } else if (e.target.id === 'product-fav-icon' && !e.shiftKey) {
                    e.preventDefault();
                    e.stopPropagation();
                    document.querySelector('#modal-close-button').focus();
                }
            } else if (e.keyCode === 27) {
                _this.hideModal();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _class2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.state.isFavorite != nextProps.isFavorite) {
            this.setState({ isFavorite: nextProps.isFavorite });
        }
    };

    _class2.prototype.render = function render() {

        var map = React.createElement(MapCanvas, {
            googleMapsHelper: this.props.googleMapsHelper,
            mapShowing: false //prevents extra triggers of selecting a location
            , isInModal: true,
            refName: 'modal_map_canvas',
            locationSelectHandler: this.props.locationSelectHandler,
            mapLoaded: function mapLoaded() {},
            locations: this.props.locations,
            handleMapLocationSelect: function handleMapLocationSelect() {},
            selectedLocationId: this.props.selectedLocationId,
            lang: this.props.lang,
            cntry: this.props.cntry });

        return React.createElement(
            'div',
            { className: 'search-result-modal', onKeyDown: this.keepTrappedInModal },
            React.createElement('div', { className: 'modal-header' }),
            React.createElement(
                'div',
                { className: 'modal-body content' },
                React.createElement(
                    'div',
                    { className: 'find-location-container' },
                    React.createElement(
                        'div',
                        { className: 'map-container' },
                        React.createElement(
                            'div',
                            { tabIndex: '-1' },
                            map
                        ),
                        React.createElement(
                            'button',
                            { id: 'modal-close-button', type: 'button', className: 'close', onClick: this.hideModal },
                            React.createElement(
                                'span',
                                { 'aria-hidden': 'true' },
                                '\xD7'
                            ),
                            React.createElement(
                                'span',
                                { className: 'sr-only' },
                                this.props.getLocalizedText('selected_result_close')
                            )
                        ),
                        React.createElement(SearchResult, _extends({}, this.props, {
                            key: this.props.location.id,
                            isFavorite: this.state.isFavorite,
                            favoriteLocationClick: this.favoriteLocationClick,
                            searchResultPinClick: function searchResultPinClick() {},
                            selectedResult: this.props.selectedResult,
                            orderButtonClick: this.props.orderButtonClick,
                            buttonType: 'ordering', id: 'modal',
                            location: this.props.location,
                            notifyClick: this.props.notifyClick }))
                    )
                )
            )
        );
    };

    return _class2;
}(React.Component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/findLocationComponents/search/SelectedResultModal.js
// module id = 799
// module chunks = 0